<template>
	<div>
		<div class="content">
			<h1 class="title is-bold">Forgot password?</h1>
			<p>
				Enter the email address associated wth your account, and we'll send you
				a link to reset your password.
			</p>
		</div>
		<form-forgotten-password
			:fetching="fetching"
			:message="message"
			:message-type="messageType"
			@submit="submit"
		></form-forgotten-password>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
	name: "AuthForgottenPassword",
	computed: {
		...mapGetters({
			fetching: "authentication/fetching",
			message: "authentication/message",
			messageType: "authentication/messageType"
		})
	},
	methods: {
		...mapActions({
			validate: "authentication/validate",
			resetpassword: "authentication/resetpassword"
		}),
		submit(data) {
			this.resetpassword(data);
		}
	}
};
</script>
